module.exports = __webpack_public_path__ + "static/grungs-1c8162a3ff5244d7e625acd064bebfe2.jpeg";